goog.provide("shadow.js.shim.module$ol$geom$LineString");
goog.provide("module$shadow_js_shim_module$ol$geom$LineString");
shadow.js.shim.module$ol$geom$LineString = shadow.js.nativeProvides["ol/geom/LineString"] = shadow$bridge("ol/geom/LineString");
module$shadow_js_shim_module$ol$geom$LineString.default = shadow.js.shim.module$ol$geom$LineString;
